<template>
  <div class="page_container warehousingPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/warehousIndex/wManageIndex' }"
          >入库管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>明细数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="btn flex-rowl" @click="handleGo(1)">
            <i class="iconfont icon-xinzeng"></i> 采购入库
          </p>
          <p class="btn flex-rowl" @click="handleGo(2)">
            <i class="iconfont icon-xinzeng"></i> 生产入库
          </p>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="detailList.length > 0">
          <div class="item_wrap" v-for="item in detailList" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl">
                  <p>
                    数量：<span>{{ item.num }}件</span>
                  </p>
                  <p>
                    位置：<span>{{ item.whid1_str }}</span>
                    <span v-if="item.whid2_str">/{{ item.whid2_str }}</span>
                    <span v-if="item.whid3_str">/{{ item.whid3_str }}</span>
                    <span v-if="item.whid4_str">/{{ item.whid4_str }}</span>
                  </p>
                  <p>
                    属性参数：<span>{{
                      item.ams_shop_commodity_attrid_str
                    }}</span>
                  </p>
                  <p>
                    商品批次：<span>{{ item.makerno }}</span>
                  </p>
                  <p>
                    生产商：<span>{{ item.makername_str }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="尚未添加入库参数"
          v-if="!loading && detailList.length == 0"
        ></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { getMenuAuthTwo, queryShopWareRecord } from "../../api/api";
export default {
  name: "wManageSettingList",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      cmid: '',
      loading: false,
      keyword: "",
      realnum: 0,
      detailList: [],
    };
  },
  created() {
    let { keyword, cmid } = this.$route.params;
    this.keyword = keyword;
    this.cmid = cmid;
    this.getWearRecord(keyword);

    this.roleId = this.$store.state.USERINFO.qy.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    // 入库记录
    getWearRecord(keyword) {
      this.loading = true;
      queryShopWareRecord({ keyword }).then((res) => {
        let num = 0;
        if (res.length > 0) {
          res.forEach((v) => {
            num += v.num;
          });
          this.realnum = num;
        }
        this.detailList = res;
        this.loading = false;
      });
    },

    handleGo(type) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$message.warning("暂无权限");
        return;
      }
      this.$router.push(
        `/warehousIndex/wManageSettingItem/${this.keyword}/${this.cmid}/${type}`
      );
    },
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingPage {
  .operation_wrap {
    .btn {
      border: 1px solid #6b5e84;
      padding: 8px 25px;
      border-radius: 45px;
      &:last-child {
        margin-left: 20px;
      }
    }
  }
  .intro_box {
    p {
      margin-right: 60px;
    }
  }
}
</style>